import { useState, useEffect } from 'react';
import axios from 'axios';

const useResources = (Ip) => {
  const [divLists, setDivLists] = useState([]);
  const [menuArray, setMenuArray] = useState([]);

  const fetchMenu = async () => {
    try {
      const formData=new FormData();
      formData.append('Action', 'pages');
      
      const response = await axios.post(`${Ip}controllers/pages.php`, formData);
      const filteredData = Object.fromEntries(
        Object.entries(response.data).filter(([category]) => category.trim() !== '')
      );

      const titleReplacements = {
        Economics: 'Economics & Finance',
        Governance: 'Governance & Human Development',
        Societal: 'Societal Transformation',
      };

      const transformedData = Object.entries(filteredData).map(([category, items]) => ({
        title: titleReplacements[category] || category,
        list: items.map((item) => ({
          id: item.id,
          item: item.title,
          itemAr: item.titleAr,
          link: item.link,
          disabled: item.visible,
        })),
      }));

      setDivLists(transformedData);
      
      setMenuArray(filteredData);
    } catch (error) {
      console.error('Error fetching menu:', error);
    }
  };

  useEffect(() => {
    fetchMenu();
  }, [Ip]);

  return { divLists, setDivLists, menuArray};
};

export default useResources;
